import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '94%',
    padding: '3% 3% 1.5%',
  },
  addButton: {
    fontFamily: 'Helvetica Neue LT Std !important',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    color: '#DF0C36 !important',
    lineHeight: '20px !important',
    top: 0,
    zIndex: 1,
    textTransform: 'none !important',
    whiteSpace: 'nowrap',
  },
  addIcon: { marginLeft: 6 },
  settingButton: {
    fontFamily: 'Helvetica Neue LT Std !important',
    fontStyle: 'normal !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    color: '#666666 !important',
    lineHeight: '20px !important',
    top: 0,
    zIndex: 1,
    marginRight: 4,
    marginBottom: 2,
    textTransform: 'none !important',
    whiteSpace: 'nowrap',
  },
  tab: {
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    color: '#333333',
    lineHeight: '20px',
    background: '#FFFFFF',
    width: 'fit-content',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
  appBar: {
    'max-height': '50px',
    'overflow-y': 'hidden',
    background: '#fafafa !important',
    position: 'relative',
    marginTop: '16px',
    zIndex: 0,
  },
  buttonGroup: {
    width: '100%',
    boxShadow: 'none !important',
    overflowX: 'auto',
    overflowY: 'hidden',
    minWidth: 'unset !important',
  },
  selectedTab: {
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    color: '#FFFFFF',
    lineHeight: '20px',
    background: '#DF0C36',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#DF0C36 !important',
    },
    '&:active': {
      backgroundColor: '#DF0C36 !important',
    },
    whiteSpace: 'nowrap',
    borderRight: '0px !important',
    minWidth: 'unset !important',
  },
  notSelectedTab: {
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    color: '#333333',
    lineHeight: '20px',
    background: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF !important',
    },
    '&:active': {
      backgroundColor: '#FFFFFF !important',
    },
    borderRight: '0px !important',
    whiteSpace: 'nowrap',
    minWidth: 'unset !important',
  },
  saveView: {
    color: '#333333',
    lineHeight: '20px',
    background: '#FFFFFF',
    border: '1px solid #ECECEC',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    width: '46px',
    height: '34px',
    alignItems: 'center',
    paddingRight: 0,
  },
  buttonTab: {
    height: '32px',
    boxShadow: 'none',
    border: '1px solid #ECECEC',
    minWidth: 'unset !important',
  },
  closeButton: {
    border: '0px solid #FFFFFF',
    background: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
    padding: '0',
    borderRadius: 0,
  },
  closeButtonSelected: {
    border: '0px solid #FFFFFF',
    background: '#DF0C36',
    '&:hover': {
      backgroundColor: '#DF0C36',
    },
    padding: '0',
    borderRadius: 0,
  },
  closeIconSelected: {
    color: '#FFFFFF',
  },
  closeIcon: {
    color: '#666666',
  },
  endBar: {
    flexWrap: 'nowrap !important',
  },
}));
